import { LogLevel } from '@azure/msal-browser';
const envClientId = process.env.REACT_APP_CLIENT_ID ? process.env.REACT_APP_CLIENT_ID.toString() : '';
export const msalConfig = {
    auth: {
        clientId: envClientId,
        authority: `https://login.microsoftonline.com/5aa016da-26bf-4f4b-b497-651dcd12a62a`,
        // redirectUri: window.location.origin + '/',
        validateAuthority: true,
        postLogoutRedirectUri: window.location.origin,
        redirectUri: window.location.origin + '/welcome',
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: 'localStorage', // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
        },
        allowRedirectInIframe: true
    },
};

// Add scopes here for api
export const apiRequest = {
    scopes: [],
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: ['User.Read', 'openid', 'profile'],
};
export const accessTokenRequest = {
    scopes: [process.env.REACT_APP_CLIENT_ID_SCOPE_API!],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
